import styled from "@emotion/styled";
import { Box, Flex } from "@rebass/grid/emotion";
import React from "react";
import { Icon } from "react-icons-kit";

const HeadIcon = styled(Icon)`
  color: #961452;
`;

const Service = ({ icon, title, description }) => (
  <Box width={[1, null, 1 / 2]} mb={4} pr={4}>
    <Flex>
      <Box width={[1 / 5]} pt={1} pl={[0, 3]}>
        <HeadIcon size={36} icon={icon} />
      </Box>
      <Box width={[4 / 5]}>
        <strong>{title}</strong>
        <br />
        {description}
      </Box>
    </Flex>
  </Box>
);

export default Service;
